// Get Vendor Info
import { authClient } from './index';
import { toast } from 'react-toastify';

import Cookie from 'universal-cookie';

const cookies = new Cookie();

const config = {
  headers: {
    'Content-Type': 'application/json',
    authorization: `Bearer ${cookies.get('authToken')}`,
  },
};

export const editProfile = async formData => {
  const cookies = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.patch(`users/update-user`, formData, config);

      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Get User Info
export const fetchUserProfile = async () => {
  const cookie = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`users/user-details`, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove('authToken', { path: '/' });
          cookie.remove('user', { path: '/' });
          cookie.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
export const fetchUserBank = async () => {
  const cookie = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`profile/getbank-details`, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove('authToken', { path: '/' });
          cookie.remove('user', { path: '/' });
          cookie.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Update Profile
export const updateSocial = async formData => {
  const cookie = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.patch(
        `/users/update-profile`,
        formData,
        config
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Get bank List
export const getBankList = async () => {
  const cookie = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`users/list-banks`, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
// Get bank List
export const getNonNigerianBanksList = async () => {
  const cookie = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/admin/get-momo-bank`, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Get Country List
export const getCountryList = async () => {
  const cookie = new Cookie();

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`users/list-country`, config);
      // console.log("ready:", res )
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
// Update Bank Detail
export const updatebBank = async data => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.patch(
        `users/update-bank-details`,
        data,
        config
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
